import dayjs from "dayjs";
export var STRICT_DATES = [
    {
        label: "last30min",
        value: dayjs().subtract(30, "minute").valueOf(),
    },
    {
        label: "last1hour",
        value: dayjs().subtract(1, "hour").valueOf(),
    },
    {
        label: "last3hours",
        value: dayjs().subtract(3, "hour").valueOf(),
    },
    {
        label: "last1day",
        value: dayjs().subtract(1, "day").valueOf(),
    },
    {
        label: "last3days",
        value: dayjs().subtract(3, "day").valueOf(),
    },
    {
        label: "last7days",
        value: dayjs().subtract(7, "day").valueOf(),
    },
];
